const getFireRiskInfo = (fireRiskValue) => {
	if(!fireRiskValue){
		return{
			riskLevel: 'Moderate',
			percentElementClassName: 'moderateRiskLevel',
			riskGaugeColor: '#f9bb71'
		}
	}else if (fireRiskValue > 8.4) {
		return {
			riskLevel: 'Very High',
			percentElementClassName: 'veryHighRiskLevel',
			riskGaugeColor: '#ff3e51'
		};
	} else if (fireRiskValue <= 8.4 && fireRiskValue > 7.3) {
		return {
			riskLevel: 'High',
			percentElementClassName: 'highRiskLevel',
			riskGaugeColor: '#ff8157'
		};
	} else if (fireRiskValue <= 7.3 && fireRiskValue >= 5.3) {
		return {
			riskLevel: 'Moderate',
			percentElementClassName: 'moderateRiskLevel',
			riskGaugeColor: '#f9bb71'
		};
	} else if (fireRiskValue < 5.3 && fireRiskValue > 3.6) {
		return {
			riskLevel: 'Low',
			percentElementClassName: 'lowRiskLevel',
			riskGaugeColor: '#b5d269'
		};
	} else {
		return {
			riskLevel: 'Very Low',
			percentElementClassName: 'veryLowRiskLevel',
			riskGaugeColor: '#45c0f0'
		};
	}
}

export default getFireRiskInfo;
